<template>
  <div class="tw-flex-1 tw-flex tw-flex-col">

    <button class="tw-flex tw-items-center tw-p-4 tw-border-b tw-border-gray-200 tw-outline-none hover:tw-bg-blue hover:tw-bg-opacity-2"
      v-on:click="states.showChatDetails = !states.showChatDetails">
      <img :src="states.activeChat.image" alt="" class="tw-w-16 tw-h-16 tw-rounded-full tw-mr-4">
      <div>
        <div class="tw-text-left">{{states.activeChat.title}}</div>
        <div class="tw-text-gray-500 tw-text-lg tw-text-left">
          <span>{{states.activeChat.members.length}} members</span>
          <span v-if="states.typingUsers.length !== 0">{{_.map(states.typingUsers,typingUser => typingUser.user.name).join(', ')}} {{states.typingUsers.length === 1 ? 'is' : 'are'}} typing..</span>
        </div>
      </div>
    </button>

    <div v-if="states.showChatDetails" class="space-y-3 tw-flex-1 tw-overflow-auto">
      <div v-for="member in states.activeChat.members" :key="member.id" class="tw-flex tw-items-center tw-p-4 hover:tw-bg-blue hover:tw-bg-opacity-2">
        <img :src="member.mid_avatar" alt="" class="tw-w-16 tw-h-16 tw-rounded-full tw-mr-4">
        <div>
          <div class="tw-text-left">{{member.name}}</div>
          <div class="tw-text-gray-500 tw-text-lg">{{member.is_trader ? 'Trader' : 'Customer'}}</div>
        </div>
      </div>
    </div>

    <div v-if="!states.showChatDetails" class="tw-flex-1 tw-overflow-auto tw-space-y-4 tw-p-4" ref="messages">
      <div v-if="states.loading_messages" class="tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center">
        <div>Loading..</div>
      </div>
      <message-item v-else v-for="message in states.messages" :key="message.id" :data="message" :user="states.user"/>
    </div>

    <form v-if="!states.showChatDetails" class="tw-w-full tw-border-t tw-border-gray-200" v-on:submit.prevent="store.sendMessage">
      <div class="tw-p-5 tw-border-b" v-if="states.form.attachments.length !== 0">
        <div class="tw-text-dark tw-text-opacity-50 tw-font-bold tw-mb-5 tw-ml-5">Attachments:</div>
        <div class="tw-grid tw-grid-cols-3 tw-gap-3 ">
          <div v-for="(attachment,index) in states.form.attachments" class="tw-rounded tw-flex tw-items-center tw-space-x-2 tw-p-3">
            <i class="bx bx-file tw-text-3xl"></i>
            <div class="tw-truncate">{{attachment.name}}</div>
            <div class="tw-flex-grow"></div>
            <button class="cursor:tw-text-red" v-on:click.prevent="store.removeAttachment(index)">
              <i class="bx bx-x tw-text-3xl"></i>
            </button>
          </div>
        </div>
      </div>
      <input type="file" multiple class="tw-hidden" ref="attachment" v-on:change="store.addAttachment($event)">
      <div class="tw-space-x-1 tw-flex tw-items-center tw-p-5 focus-within:tw-bg-light-2">
        <button class="tw-p-3 cursor:tw-text-blue" v-on:click.prevent="$refs.attachment.click()">
          <i class="bx bx-file tw-text-3xl"></i>
        </button>
        <input type="text"
          v-on:keydown.enter.prevent="store.sendMessage" v-model="states.form.message"
          v-on:keypress="() => store.broadcastTyping()"
          placeholder="Send A Message.."
          class="tw-flex-1 tw-rounded tw-p-5 tw-bg-transparent tw-mb-0 tw-resize-none leading-loose"
        />
        <button class="tw-p-3 cursor:tw-text-blue">
          <i class="bx bx-send tw-text-3xl"></i>
        </button>
      </div>
    </form>

  </div>

</template>
<script>
  import store from './messenger-store'
  import MessageItem from "./messenger-message-item";

  export default {
    components: {
      MessageItem,
    },
    created() {
      this.store = store
      store.bus.$on('scroll-to-last-message', () => {
        this.$refs.messages && this.$nextTick(() => {
          this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
        })
      })
    },
    data: v => ({
      states: store.states
    }),
  }
</script>
